import { gql } from "@apollo/client";

export const BOOKINGS = gql`
  query queryBookings($franchise_id: Float, $acting_region_id: Float, $callcenter: Boolean, $passenger_id: Float, $limit: Int) {
    bookings(franchise_id: $franchise_id, acting_region_id: $acting_region_id, callcenter: $callcenter, passenger_id: $passenger_id, limit: $limit) {
      id
      passenger {
        id
        name
        phone
        image_path
      }
      passenger_id
      driver {
        id
        name
        phone
        image_path
        evaluation
      }
      notifiedDrivers {
        id
        name
        phone
        version
      }
      notifieds {
        booking_id
        driver_id
        received
      }
      driver_id
      service {
        id
        name
        description
      }
      service_id
      reason {
        id
        name
        type
        page
      }
      reason_id
      original_value
      offered_value
      offered_value_driver
      base_rate
      minimum_price
      cost_per_minute
      cost_per_km
      booking_fee
      origin_latitude
      origin_longitude
      origin_address
      destiny_latitude
      destiny_longitude
      destiny_address
      stops
      lastQueue
      payment_type
      state
      routeTime
      distance
      is_callcenter
      is_deleted
      created_at
      updated_at
      expired_at
      accepted_at
      canceled_at
      route_at
      vessel_at
      completed_at
    }
    franchises {
      id
      name
    }
    regions(franchise_id: $franchise_id) {
      id
      name
    }
  }
`;

export const BOOKING = gql`
  query queryBooking($id: Int!) {
    booking(id: $id) {
      id
      passenger {
        id
        name
        image_path
      }
      passenger_id
      driver {
        id
        name
        image_path
        is_online
        latitude
        longitude
        vehicles {
          id
          brand
          model
          color
          year
          image_path
          board
        }
        evaluation
      }
      driver_id
      service {
        id
        name
        boarding_waiting_time_in_seconds
        max_meters_request_drivers
        max_search_booking_in_seconds
        icon_path
      }
      service_id
      reason {
        id
        name
        type
        page
      }
      reason_id
      original_value
      offered_value
      offered_value_driver
      base_rate
      minimum_price
      cost_per_minute
      cost_per_km
      booking_fee
      payment_type
      origin_latitude
      origin_longitude
      origin_address
      destiny_latitude
      destiny_longitude
      destiny_address
      lastQueue
      state
      routeTime
      distance
      is_deleted
      created_at
      updated_at
      expired_at
      accepted_at
      canceled_at
      route_at
      vessel_at
      completed_at
    }
  }
`;

export const SUMBOOKING = gql`
  query queryBooking($ini_date: DateTime!, $fin_date: DateTime!, $franchise_id: Float, $acting_region_id: Float) {
    sumBookings(ini_date: $ini_date, fin_date: $fin_date, franchise_id: $franchise_id, acting_region_id: $acting_region_id) {
      final_value
      countRace
      countCompleted
      countCanceled
      countDrivers
      countDriversOn
    }
    franchises {
      id
      name
    }
    regions(franchise_id: $franchise_id) {
      id
      name
    }
  }
`;

export default BOOKINGS;
